import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onQuoteClick: () => void;
}

const CTASection = ({ onQuoteClick }: CTASectionProps) => {
  return (
    <section className="py-16 md:py-24 bg-desert-gradient">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl mb-6">
            Ready to Transform Your Patio?
          </h2>
          <p className="font-body text-lg md:text-xl mb-8 opacity-95 leading-relaxed">
            Get a free, no-obligation quote today and discover why Phoenix Metro homeowners trust us for professional patio cleaning services
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button
              onClick={onQuoteClick}
              className="px-8 py-4 bg-white text-primary rounded-lg font-body font-semibold text-lg hover:bg-white/90 transition-brand shadow-brand-elevated flex items-center justify-center"
            >
              <Icon name="DocumentTextIcon" size={24} className="mr-2" />
              Request Free Quote
            </button>
            <Link
              href="tel:+16027773005"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-lg font-body font-semibold text-lg hover:bg-white/20 transition-brand flex items-center justify-center"
            >
              <Icon name="PhoneIcon" size={24} className="mr-2" />
              (602) 777-3005
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8 border-t border-white/20">
            <div className="flex items-center justify-center gap-3">
              <Icon name="ClockIcon" size={32} className="text-white/90" />
              <div className="text-left">
                <div className="font-headline font-semibold text-lg">24-Hour Response</div>
                <div className="font-body text-sm opacity-90">Quick quote turnaround</div>
              </div>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Icon name="ShieldCheckIcon" size={32} className="text-white/90" />
              <div className="text-left">
                <div className="font-headline font-semibold text-lg">Satisfaction Guaranteed</div>
                <div className="font-body text-sm opacity-90">100% quality promise</div>
              </div>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Icon name="CurrencyDollarIcon" size={32} className="text-white/90" />
              <div className="text-left">
                <div className="font-headline font-semibold text-lg">Transparent Pricing</div>
                <div className="font-body text-sm opacity-90">No hidden fees</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;